/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type STORY_STATUS = "CLOSED" | "OPEN" | "%future added value";
export type StoryActionsContainer_story = {
    readonly id: string;
    readonly status: STORY_STATUS;
    readonly " $refType": "StoryActionsContainer_story";
};
export type StoryActionsContainer_story$data = StoryActionsContainer_story;
export type StoryActionsContainer_story$key = {
    readonly " $data"?: StoryActionsContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"StoryActionsContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StoryActionsContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '194605be732036ad8c0adb493db8edde';
export default node;
